import defaultState, { defaultInfo } from './defaultState'

const unwrapState = state => state.job || defaultState

export const getJobInfo = state => unwrapState(state).info || defaultInfo
export const getJobLoading = state => unwrapState(state).loading
export const getJobLoaded = state => getJobInfo(state).id
export const getJobError = state => unwrapState(state).error
export const getJobContentLoaded = state => unwrapState(state).iframeLoaded
